// Re-export from shared package for backward compatibility
export { isLessonBookable, getLessonBookingReason } from '@court-sync/shared';

/**
 * Check if a lesson is fully booked (capacity reached).
 * Lessons with maxCapacity -1 (unlimited) are never considered full.
 * When allowEnrolmentWhenFull is true, the lesson is never considered full.
 */
export function isLessonFull(
  lesson: { maxCapacity?: number; currentEnrollment?: number },
  allowEnrolmentWhenFull?: boolean
): boolean {
  if (lesson.maxCapacity === undefined || lesson.maxCapacity === -1) return false;
  if (allowEnrolmentWhenFull) return false;
  return (lesson.currentEnrollment || 0) >= lesson.maxCapacity;
}

